import useGa from 'Client/hooks/useGa';
import {
    TrackLLPImpressionEvents,
    TrackLooksActions,
    LOOKS_LISTING_PAGE_TYPE,
    LOOKS_DETAIL_PAGE_TYPE,
} from 'Common/ga/types';
import { StyleFilterEntry, FormattedRooms } from 'Client/redux/looksPage/types';
import { LookDetail } from 'Client/redux/lookDetail/types';
import useConfig from 'Client/hooks/useConfig';
import useRouter from 'Client/hooks/useRouter';
import { WishlistTrackingParameter } from 'Common/appshell_types';

export const useLooksTracking = () => {
    const gaTracking = useGa();
    const {
        host,
        location: { pathname },
    } = useRouter();
    const { currency } = useConfig();

    const absoluteUrl = `${host}${pathname}`;
    return {
        LLP: {
            track: (action: TrackLooksActions, label: string) => {
                gaTracking.trackLLP({ action, label });
            },
            trackImpression: (event: TrackLLPImpressionEvents, action: TrackLooksActions, label: string) => {
                gaTracking.trackLLPImpressionEvent(event, { action, label });
            },
            trackPageView: (selectedRoom: FormattedRooms, selectedStyle: StyleFilterEntry, page: number) => {
                gaTracking.trackPageView({
                    pageType: LOOKS_LISTING_PAGE_TYPE,
                    gaData: {
                        room: selectedRoom?.trackingName || '',
                        style: selectedStyle?.trackingName || '',
                        page: page.toString(),
                    },
                });
            },
        },
        LDP: {
            track: (action: TrackLooksActions, label: string) => {
                gaTracking.trackLDP({ action, label });
            },
            trackWishlist: ({ action, sku, category, name, brand, price }: WishlistTrackingParameter) => {
                gaTracking.trackWishListHeartClick({
                    action,
                    label: `LDP,${sku}`,
                    sku,
                    category,
                    name,
                    brand,
                    price,
                    currency,
                    url: absoluteUrl,
                });
            },
            trackPageView: (look: LookDetail) => {
                gaTracking.trackPageView({ pageType: LOOKS_DETAIL_PAGE_TYPE, gaData: { look: look.trackingName } });
            },
            trackConnectedLooksClick: (
                action: TrackLooksActions.LDPPrevLookClick | TrackLooksActions.LDPNextLookClick,
                label: string
            ) => {
                gaTracking.trackLDP({ action, label });
            },
        },
    };
};
